// extracted by mini-css-extract-plugin
module.exports = {"page":"Layout_page__S1cKp","main":"Layout_main__Fn5Ho"};